import Vue from 'vue'
import App from './App.vue'
import router from './routes'
// import store from './store'
// import VueAllAuth from 'vue-all-auth'
import VueAxios from 'vue-axios'
import axios from 'axios'
import api from '@/utils/api'
import helper from '@/utils/helpers'
import filters from '@/utils/filters'
import * as VueGoogleMaps from 'vue2-google-maps'
import SocialSharing from 'vue-social-sharing'
import PayPal from 'vue-paypal-checkout'
import Vue2TouchEvents from 'vue2-touch-events'
import persistentState from 'vue-persistent-state'
import lodash from 'lodash'

import Framework7 from 'framework7/framework7.esm.bundle.js'
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js'
import 'framework7/css/framework7.bundle.css'
import './assets/css/icons.css'
import '@/assets/scss/main.scss'

Framework7.use(Framework7Vue)
Vue.use(VueAxios, axios)
Vue.use(api)
Vue.use(helper)
Vue.use(VueGoogleMaps, { load: { key: 'AIzaSyAo4NPg6au3bkwCwWxlbAhSSze0qosHVEU', libraries: 'places' } })
Vue.use(SocialSharing)
Vue.use(Vue2TouchEvents)
Vue.use(filters)

Vue.use({
  install: (Vue, options) => {
    Vue.$evento = Vue.prototype.$evento = new Framework7.Events()
    Vue.$lodash = Vue.prototype.$lodash = lodash
  }
})

Vue.use(persistentState, {
  storage: {
    aviso: false,
    version: 0,
    carrito: [],
    wishlist: [],
    usuario: {},
    montura: '',
    diamante: '',
    token: '',
    cupon: {
      codigo: '',
      porcentaje: '',
      valido: false
    },
    guardarEnvio: false,
    guardarFacturacion: false,
    guardarDetalles: false,
    venta: false,
    transaccion: {
      montura: '',
      diamante: '',
      token: '',
      usuario: '',
      guardarEnvio: false,
      guardarFacturacion: false,
      guardarDetalles: false,
      venta: false,
      carrito: '',
      transaccion: {
        id: '',
        intent: 'sale',
        state: '', // approved, declined
        cart: '',
        create_time: '',
        promos: [],
        payer: {
          payment_method: 'visa',
          status: '-',
          payer_info: {
            email: '',
            first_name: '',
            middle_name: '',
            last_name: '',
            payer_id: '-',
            country_code: 'MX',
            shipping_address: {
              recipient_name: '',
              line1: '',
              city: '',
              state: '',
              postal_code: '',
              country_code: 'MX',
              suburb: ''
            },
            phone: '',
            name: ''
          }
        },
        transactions: [
          {
            amount: {
              total: '',
              currency: '',
              details: {}
            },
            item_list: {
              items: []
            },
            related_resources: []
          }
        ]
      }
    }
  }
})

Vue.component('paypal', PayPal)

// Vue.use(VueAllAuth, {
//   google: {
//     // keys for google
//     client_id: '187481245553-jvc3sp7ul72v3p8hg65t0e3tndljg1ec.apps.googleusercontent.com',
//     scope: 'profile email'
//   },
//   facebook: {
//     // keys for fb
//     appId: '363052277725882',
//     cookie: true,
//     xfbml: true,
//     version: 'v3.2'
//   },
//   twitter: {
//     // keys for twitter
//   }
// })

// Vue.allAuth().google().init()
// Vue.allAuth().facebook().init()

Vue.config.productionTip = false
new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
